import * as SEARCH_ACTIONS from 'constant/action/search'
import * as LOADER_ACTIONS from 'constant/action/loader'
import * as PAGINATION from 'constant/pagination'
import * as TABLE from 'constant/table'
import * as NUMBER from 'constant/number'
import { createAction } from 'redux-actions'
import { buildCategory, filterResultsBuilder } from 'helper/create-category-object'
import _ from 'lodash'

const updateSearch = createAction(SEARCH_ACTIONS.UPDATE_SEARCH)
const updateLoadingSearchResults = createAction(LOADER_ACTIONS.UPDATE_LOADING_SEARCH_RESULTS)
const updatePagination = createAction(SEARCH_ACTIONS.UPDATE_SEARCH_PAGINATION)
const updateSearchTerm = createAction(SEARCH_ACTIONS.UPDATE_SEARCH_TERM)
const updateTreeObject = createAction(SEARCH_ACTIONS.UPDATE_TREE_OBJECT)
const updateSelectedKeys = createAction(SEARCH_ACTIONS.UPDATE_SELECTED_KEYS)

export const searchAll = (searchTerm, spread = false, start = NUMBER.ZERO, localLoad = false) => async (dispatch, getState, { search }) => {
  dispatch(updateLoadingSearchResults(!localLoad))
  dispatch(updateSearchTerm(searchTerm))
  dispatch(updatePagination({
    start
  }))
  const {
    search: searchState
  } = getState()
  const response = await search.searchAll(searchTerm, PAGINATION.SORT.SEARCH, PAGINATION.DESCENDING, TABLE.PAGE_SIZE, _.isNumber(start) ? start : _.get(searchState, 'searchResults.start'))
  if (spread) {
    response.results = [...searchState.searchResults.results, ...response.results]
  }

  const { categories, defaultSelectedKeys } = await buildCategory(response)
  const treeObject = await createTreeObject(categories)
  dispatch(updateTreeObject(treeObject))
  dispatch(updateSelectedKeys(defaultSelectedKeys))
  dispatch(updateSearch(response))
  dispatch(updateLoadingSearchResults(false))
}

export const createTreeObject = (categories) => (
  Object.values(
    categories
      .reduce((result, category) => {
        const site = result[category.site_uuid] || (
          result[category.site_uuid] = {
            checkable: false,
            children: [],
            key: category.site_uuid,
            selectable: false,
            title: category.site_name,
            value: category.site_uuid
          })
        if (!_.isEmpty(category.sub_category)) {
          site.children.push({
            children: category.sub_category.map((subCategory) => ({
              key: subCategory.uuid,
              title: subCategory.name,
              value: subCategory.uuid
            })),
            key: category.uuid,
            title: category.name,
            value: category.uuid
          })
        } else {
          site.children.push({
            key: category.uuid,
            title: category.name,
            value: category.uuid
          })
        }

        return result
      }, {})
  ))

export const filterResults = (filterValues, start = NUMBER.ZERO) => async (dispatch, getState, { search }) => {
  dispatch(updateLoadingSearchResults(true))
  const {
    search: searchState
  } = getState()

  const response = await search.searchAll(searchState.searchTerm, PAGINATION.SORT.ARTICLES, PAGINATION.DESCENDING, TABLE.PAGE_SIZE, _.isNumber(start) ? start : _.get(searchState, 'searchResults.start'))

  if (!_.isEmpty(filterValues)) {
    const chosenArticles = await filterResultsBuilder(response, filterValues)
    response.results = _.compact(chosenArticles)
    response.full_count = response.results.length < response.limit ? response.results.length : response.full_count
  }

  dispatch(updateSearch(response))
  dispatch(updateLoadingSearchResults(false))
}
